import script from "./PotentialDiagnosisPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialDiagnosisPopUp.vue?vue&type=script&setup=true&lang=js"

import "./PotentialDiagnosisPopUp.vue?vue&type=style&index=0&id=148044f8&lang=css"

const __exports__ = script;

export default __exports__